import type { CheckoutRes } from "~/types/checkout"
import { joinURL } from "ufo"

export function useCheckout() {
  const sessionId = useVippsCheckoutSessionId()

  const termsAccepted = ref(false)

  const origin = useCurrentOrigin()

  const router = useRouter()

  const api = useApiClients()

  async function submit(params: { product: string, variant: string }, productId: string): Promise<void> {
    if (!termsAccepted.value)
      throw new Error("terms not accepted")

    const variantRoute = router.resolve({
      name: "variant",
      params,
      query: { "pay-redirect": String(true) },
    })

    const data = await api.ecommerce<CheckoutRes>("/rest/checkout", {
      method: "POST",
      params: {
        productSource: "CRYSTALLIZE_KUNNE",
        redirectUrl: joinURL(origin, variantRoute.fullPath),
      },
      body: {
        productId,
        paymentSource: "VIPPS",
      },
    })

    sessionId.value = data.sessionId

    window.VippsCheckout({
      checkoutFrontendUrl: data.paymentCheckoutFrontendUrl,
      iFrameContainerId: "vipps-checkout-frame-container",
      language: "no",
      token: data.paymentToken,
    })
  }

  return {
    termsAccepted,
    submit,
  }
}
